import React from "react";
import { Link } from "react-router-dom";
import { formatCount } from "../../../common/helpers";

interface StatsCardProps {
  title: string;
  value: number;
  totalValue?: number;
  icon: string;
  iconColor?: string;
  percentage?: number;
  percentageDirection?: "up" | "down" | "neutral";
  percentageText?: string;
  valueColor?: string;
  totalValueColor?: string;
  onClick?: () => void;
  href?: string;
  modalTarget?: string;
  className?: string;
}

const StatsCard: React.FC<StatsCardProps> = ({
  title,
  value,
  totalValue,
  icon,
  iconColor = "text-primary",
  percentage,
  percentageDirection = "up",
  percentageText,
  valueColor = "",
  totalValueColor = "text-danger",
  onClick,
  href = "#",
  modalTarget,
  className = "",
}) => {
  const getPercentageIcon = () => {
    switch (percentageDirection) {
      case "up":
        return "ti-arrow-wave-right-up";
      case "down":
        return "ti-arrow-wave-right-down";
      case "neutral":
        return "ti-minus";
      default:
        return "ti-arrow-wave-right-up";
    }
  };

  const getPercentageColor = () => {
    switch (percentageDirection) {
      case "up":
        return "text-success";
      case "down":
        return "text-danger";
      case "neutral":
        return "text-warning";
      default:
        return "text-success";
    }
  };

  const cardContent = (
    <div className="d-flex align-items-center h-100 ">
      <div className={`stat-icon me-3 ${iconColor}`}>
        <i className={`ti ${icon} fs-28`}></i>
      </div>
      <div className="stat-content flex-grow-1">
        <p className="stat-title mb-1 text-muted small">{title}</p>
        <h4 className={`stat-value mb-0 ${valueColor}`}>
          {formatCount(value)}
          {totalValue && (
            <span className={`${totalValueColor} fs-6`}> / {totalValue}</span>
          )}
        </h4>
        {(percentage !== undefined || percentageText) && (
          <div className="stat-meta mt-1">
            <small className="d-flex align-items-center">
              {percentage !== undefined && (
                <span className={`${getPercentageColor()} me-1`}>
                  <i className={`ti ${getPercentageIcon()} me-1`} />
                  {percentage}%
                </span>
              )}
              {percentageText && (
                <span className="text-muted">{percentageText}</span>
              )}
            </small>
          </div>
        )}
      </div>
    </div>
  );

  return (
    <div
      className={`card stats-card ${className} `}
      style={{ minWidth: "98%", maxWidth: "98%" }}>
      <div className="card-body px-3 py-4 bg-white">
        {modalTarget || onClick ? (
          <Link
            to={href}
            {...(modalTarget && {
              "data-bs-toggle": "modal",
              "data-bs-target": modalTarget,
            })}
            onClick={onClick}
            className="text-decoration-none d-block h-100">
            {cardContent}
          </Link>
        ) : (
          cardContent
        )}
      </div>
    </div>
  );
};

export default StatsCard;
